<mat-toolbar>
    <div fxLayout="row" fxLayoutAlign="center center" fxFlex>
        <div fxLayout="row" fxLayoutAlign="start center" fxHide fxShow.gt-xs>
          <div class="px-4">{{appName}} {{appVersion}} {{appCopyright}}</div>
          <div class="footer-links">
            <div style="padding-left: 12px; padding-right: 2px;"><a href="terms-of-use.html" target="_blank" rel="noopener noreferrer" style="color: rgba(255,255,255,0.87)">Terms of Use</a></div>
            <div style="padding-left: 2px; padding-right: 2px;"><span>-</span></div>
            <div style="padding-left: 2px; padding-right: 2px;"><a href="privacy-policy.html" target="_blank" rel="noopener noreferrer" style="color: rgba(255,255,255,0.87)">Privacy Policy</a></div>
            <div style="padding-left: 2px; padding-right: 2px;"><span>-</span></div>
            <div style="padding-left: 2px; padding-right: 4px;"><a href="accessibility-statement.html" target="_blank" rel="noopener noreferrer" style="color: rgba(255,255,255,0.87)">Accessibility Statement</a></div>
          </div>
      </div>
    </div>
</mat-toolbar>
